import { SupportIssue } from "./SupportIssue";

import React from "react";

export function Notice({kind="info",children}:{kind?:"info"|"warn"|"error";children:React.ReactNode}) { return <div className={"notice "+kind} role={kind==="error"?"alert":"status"}>{children}{kind==="error"&&<SupportIssue/>}</div>; }
